module.exports = "\n<div class=\"panel\" data-bind=\"visible: visible, attr: {'component_name':componentName, 'id': id}\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <h4>Review and Approve Editor</h4>\n            <tab-review-approve params=\"selectedJob: selectedJob, messageObj:workflowMessageObj\"></tab-review-approve>\n            <tab-editor id=\"ReviewEditorID\" params=\"selectedJob: selectedJob, mode: 'Review', messageObj:editorMessageObj\"></tab-editor>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/components/review/review-editor/review-editor.html
// module id = 668
// module chunks = 0